import { render, staticRenderFns } from "./EinvoiceDetail.vue?vue&type=template&id=54bd85f8&scoped=true"
import script from "./EinvoiceDetail.vue?vue&type=script&lang=js"
export * from "./EinvoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./EinvoiceDetail.vue?vue&type=style&index=0&id=54bd85f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bd85f8",
  null
  
)

export default component.exports